import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Check, X } from 'lucide-react';

import { Flex } from 'src/components/flex';
import { formatFactValue } from 'src/components/lead-sidebar/displayed-lead-facts';
import type { IFactSuggestion } from 'src/services/lead-facts/types';

import styles from 'src/pages/landlord/leads/messages/components/nudges/LeadFactSuggestions.module.css';

type Props = {
    suggestions: IFactSuggestion[];
    onAccept: (suggestion: IFactSuggestion) => void;
    onDismiss: (suggestion: IFactSuggestion) => void;
};

/** Single-focus nudge asking the landlord to add detected facts (pet, income, voucher, ...) to the lead's info. */
export const LeadFactSuggestions = ({ suggestions, onAccept, onDismiss }: Props) => {
    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div className={styles.bar} data-testid="lead-fact-suggestions">
            <Typography variant="subtitle2" className={styles.heading}>
                Do you want to add the following to the lead info?
            </Typography>
            <Flex columnGap={1} flexWrap="wrap" alignItems="center">
                {suggestions.slice(0, 3).map((s) => (
                    <div key={s.key} className={styles.chip} data-testid={`fact-suggestion-${s.key}`}>
                        <Typography variant="body2" component="span">
                            {s.label}:
                        </Typography>
                        <Typography variant="subtitle2" component="span">
                            {formatFactValue(s.key, s.value)}
                        </Typography>
                        <IconButton
                            size="small"
                            color="primary"
                            data-testid={`accept-fact-${s.key}`}
                            onClick={() => onAccept(s)}
                        >
                            <Check size={18} />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="error"
                            className={styles.dismissButton}
                            data-testid={`dismiss-fact-${s.key}`}
                            onClick={() => onDismiss(s)}
                        >
                            <X size={18} />
                        </IconButton>
                    </div>
                ))}
            </Flex>
        </div>
    );
};

export default LeadFactSuggestions;
